module.exports = __webpack_public_path__ + "static/media/horizontal-invertida.c7616b45.png";